<div class="header-button">
  <!--
  <button mat-button [matMenuTriggerFor]="languages" aria-label="mode" class="header-item">
    <a class="pc-head-link">
      <svg class="pc-icon">
        <use xlink:href="assets/fonts/custom-icon.svg#custom-global"></use>
      </svg>
    </a>
  </button>
  <button mat-button [matMenuTriggerFor]="setting" aria-label="mode" class="header-item">
    <a class="pc-head-link">
      <svg class="pc-icon">
        <use xlink:href="assets/fonts/custom-icon.svg#custom-setting-2"></use>
      </svg>
    </a>
  </button>
  <button mat-button (click)="headerBlur(); drawer.toggle()" aria-label="mode" class="header-item" [ngClass]="{ on: headerBlur }">
    <a class="pc-head-link">
      <svg class="pc-icon">
        <use xlink:href="assets/fonts/custom-icon.svg#custom-flash"></use>
      </svg>
    </a>
  </button>
  <button mat-button [matMenuTriggerFor]="Notification" aria-label="mode" class="header-item">
    <a href="javascript:" class="pc-head-link badge-on-button" matBadge="4" matBadgeColor="primary"
      matBadgeOverlap="false">
      <svg class="pc-icon">
        <use xlink:href="assets/fonts/custom-icon.svg#custom-notification"></use>
      </svg>
    </a>
  </button>
  <button mat-button [matMenuTriggerFor]="user" aria-label="mode" class="header-item">
    <a class="pc-head-link">
      <img src="assets/images/user/avatar-2.jpg" alt="user-image" class="user-avatar" />
    </a>
  </button>
  -->

  <mat-menu #languages="matMenu" xPosition="before">
    <button mat-menu-item>
      <div class="mat-body" (click)="useLanguage('en')">English (uk)</div>
    </button>
    <button mat-menu-item>
      <div class="mat-body" (click)="useLanguage('fr')">français</div>
    </button>
    <button mat-menu-item>
      <div class="mat-body" (click)="useLanguage('ro')">Română</div>
    </button>
    <button mat-menu-item>
      <div class="mat-body" (click)="useLanguage('cn')">中国人</div>
    </button>
  </mat-menu>
  <mat-menu #setting="matMenu" xPosition="before">
    <button mat-menu-item>
      <div class="dropdown-item">
        <i class="ti ti-user"></i>
        <span class="mat-body">My Account</span>
      </div>
    </button>
    <button mat-menu-item>
      <div class="dropdown-item">
        <i class="ti ti-settings"></i>
        <span class="mat-body">Settings</span>
      </div>
    </button>
    <button mat-menu-item>
      <div class="dropdown-item">
        <i class="ti ti-headset"></i>
        <span class="mat-body">Support</span>
      </div>
    </button>
    <button mat-menu-item>
      <div class="dropdown-item">
        <i class="ti ti-lock"></i>
        <span class="mat-body">Lock Screen</span>
      </div>
    </button>
    <button mat-menu-item>
      <div class="dropdown-item">
        <i class="ti ti-power"></i>
        <span class="mat-body">Logout</span>
      </div>
    </button>
  </mat-menu>
  <mat-drawer #drawer position="end" class="notification-status sidenav" mode="over">
    <div class="drawer-header">
      <h5>What’s new announcement?</h5>
      <button type="button" mat-icon-button class="close-drawer" (click)="headerBlur(); drawer.toggle()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <ng-scrollbar style="height: calc(100vh - 88px)" visibility="hover">
      <div class="drawer-body">
        <h6 class="m-b-10">Today</h6>
        <app-card [showHeader]="false" padding="16" cardClass="m-b-15">
          <div class="flex align-item-center m-b-15">
            <div class="mat-subtitle-2 badge-status bg-success-50 text-success-500 m-r-10">New Feature</div>
            <p class="mat-body m-b-0 m-r-10 text-muted">Just Now</p>
            <span class="mat-body badge dot bg-warn-500"></span>
          </div>
          <h5 class="m-b-15">Select Business Unit</h5>
          <p class="mat-body text-muted text-wrap">
            You can use the Analytics Dashboard to explore how many new users download reports daily and monthly
          </p>
          <img class="m-b-15 img-fluid" src="assets/images/layout/img-announcement-1.png" alt="img" />
          <div class="row">
            <div class="col-md-6">
              <div class="grid">
                <button mat-stroked-button>Skip Intro</button>
              </div>
            </div>
            <div class="col-md-6">
              <div class="grid">
                <button mat-flat-button color="primary">Next</button>
              </div>
            </div>
          </div>
        </app-card>
        <app-card [showHeader]="false" padding="16" cardClass="m-b-15">
          <div class="flex align-item-center m-b-15">
            <div class="mat-subtitle-2 badge-status bg-warning-50 text-warning-500 m-r-10">Meeting</div>
            <p class="mat-body m-b-0 m-r-10 text-muted">2 min ago</p>
            <span class="mat-body badge dot bg-warn-500"></span>
          </div>
          <h5 class="m-b-15">General Meeting for update</h5>
          <p class="mat-body text-muted text-wrap">
            You can use the Analytics Dashboard to explore how many new users download reports daily and monthly
          </p>
          <img class="img-fluid" src="assets/images/layout/img-announcement-2.png" alt="img" />
        </app-card>
        <h6 class="m-b-10">Yesterday</h6>
        <app-card [showHeader]="false" padding="16" cardClass="m-b-15" *ngFor="let task of notification">
          <div class="flex align-item-center m-b-15">
            <div class="mat-subtitle-2 badge-status bg-primary-50 text-primary-500 m-r-10">{{ task.sub_title }}</div>
            <p class="mat-body m-b-0 m-r-10 text-muted">{{ task.time }}</p>
            <span class="mat-body badge dot bg-warn-500"></span>
          </div>
          <h5 class="m-b-15">{{ task.title }}</h5>
          <p class="mat-body text-muted text-wrap">
            We've made some updates to the emendable widget which we think you are going to love.
          </p>
          <img class="img-fluid" src="{{ task.img }}" alt="img" />
        </app-card>
      </div>
    </ng-scrollbar>
  </mat-drawer>
  <mat-menu #Notification="matMenu" xPosition="before" class="dropdown-notification">
    <div class="dropdown-header flex align-item-center justify-content-between">
      <h5 class="m-b-0">Notification</h5>
      <a href="javascript:" class="mat-body text-primary-500">Mark all read</a>
    </div>
    <ng-scrollbar style="height: calc(100vh - 215px)" visibility="hover">
      <div class="dropdown-body">
        <h6 class="m-b-10">Today</h6>
        <app-card [showHeader]="false" cardClass="notification-card m-b-10" padding="16" *ngFor="let card of cards">
          <div class="flex">
            <div class="topic-icon flex-shrink-0">
              <svg class="pc-icon text-primary-500">
                <use attr.xlink:href="assets/fonts/custom-icon.svg#{{ card.icon }}"></use>
              </svg>
            </div>
            <div class="topic-description flex-grow-1 m-l-15">
              <span class="mat-small float-end text-muted">{{ card.time }}</span>
              <h5 class="m-b-10">{{ card.position }}</h5>
              <p class="m-b-0 mat-body">{{ card.description }}</p>
            </div>
          </div>
        </app-card>
        <h6 class="m-b-10">Yesterday</h6>
        <app-card [showHeader]="false" cardClass="notification-card m-b-10" padding="16" *ngFor="let card of cards2">
          <div class="flex">
            <div class="topic-icon">
              <svg class="pc-icon text-primary-500">
                <use attr.xlink:href="assets/fonts/custom-icon.svg#{{ card.icon }}"></use>
              </svg>
            </div>
            <div class="topic-description m-l-15">
              <span class="mat-small float-end text-muted">{{ card.time }}</span>
              <h5 class="m-b-10">{{ card.position }}</h5>
              <p class="m-b-0 mat-body">{{ card.description }}</p>
            </div>
          </div>
        </app-card>
        <app-card [showHeader]="false" cardClass="notification-card m-b-10" padding="16">
          <div class="flex">
            <div class="topic-icon">
              <svg class="pc-icon text-primary-500">
                <use xlink:href="assets/fonts/custom-icon.svg#custom-user-bold"></use>
              </svg>
            </div>
            <div class="topic-description m-l-15">
              <span class="mat-small float-end text-muted">15 hour ago</span>
              <h5 class="m-b-10">Challenge invitation</h5>
              <p class="m-b-2 mat-body">Jonny aber invites to join the challenge</p>
              <button mat-stroked-button class="m-r-10">Decline</button>
              <button mat-raised-button color="primary">Accept</button>
            </div>
          </div>
        </app-card>
      </div>
    </ng-scrollbar>
  </mat-menu>
  <mat-menu #user="matMenu" xPosition="before" class="dropdown-user-profile">
    <div class="dropdown-header flex align-item-center justify-content-between">
      <h5 class="user-title">Profile</h5>
    </div>
    <ng-scrollbar style="height: calc(100vh - 225px)" visibility="hover">
      <div class="dropdown-body">
        <div class="flex m-b-5">
          <div class="topic-icon">
            <img src="assets/images/user/avatar-2.jpg" alt="user-images" class="user-avatar" />
          </div>
          <div class="topic-description m-l-15">
            <h6 class="user-name">Carson Darrin 🖖</h6>
            <p class="mat-body">carson.darrin@company.io</p>
          </div>
        </div>
        <mat-divider class="m-b-15 m-t-15"></mat-divider>
        <app-card [showHeader]="false" padding="16">
          <div class="flex align-items-center justify-content-between">
            <h5 class="m-b-0 flex-inline align-item-center f-16 f-w-600">
              <svg class="pc-icon text-muted m-r-10">
                <use xlink:href="assets/fonts/custom-icon.svg#custom-notification-outline"></use>
              </svg>
              Notification
            </h5>
            <mat-slide-toggle color="primary" (click)="$event.stopPropagation()"></mat-slide-toggle>
          </div>
        </app-card>
        <h6 class="m-b-15">Manage</h6>
        <a href="javascript:" class="dropdown-item text-muted">
          <svg class="pc-icon m-r-10">
            <use xlink:href="assets/fonts/custom-icon.svg#custom-setting-outline"></use>
          </svg>
          <h6 class="m-b-0">Settings</h6>
        </a>
        <a href="javascript:" class="dropdown-item text-muted">
          <svg class="pc-icon m-r-10">
            <use xlink:href="assets/fonts/custom-icon.svg#custom-share-bold"></use>
          </svg>
          <h6 class="m-b-0">Share</h6>
        </a>
        <a href="javascript:" class="dropdown-item text-muted">
          <svg class="pc-icon m-r-10">
            <use xlink:href="assets/fonts/custom-icon.svg#custom-lock-outline"></use>
          </svg>
          <h6 class="m-b-0">Change Password</h6>
        </a>
        <mat-divider class="m-b-15 m-t-15"></mat-divider>
        <h6 class="m-b-15">Team</h6>
        <a href="javascript:" class="dropdown-item text-muted justify-content-between">
          <span class="flex">
            <svg class="pc-icon m-r-10">
              <use xlink:href="assets/fonts/custom-icon.svg#custom-profile-2user-outline"></use>
            </svg>
            <h6 class="m-b-0">UI Design team</h6>
          </span>
          <div class="user-group">
            <img src="assets/images/user/avatar-1.jpg" alt="user-images" class="avatar" />
            <span class="avatar bg-warn-500 text-white">K</span>
            <span class="avatar bg-success-500 text-white">
              <svg class="pc-icon">
                <use xlink:href="assets/fonts/custom-icon.svg#custom-user"></use>
              </svg>
            </span>
            <span class="avatar bg-primary-50 text-primary-500">+2</span>
          </div>
        </a>
        <a href="javascript:" class="dropdown-item text-muted justify-content-between">
          <span class="flex">
            <svg class="pc-icon m-r-10">
              <use xlink:href="assets/fonts/custom-icon.svg#custom-profile-2user-outline"></use>
            </svg>
            <h6 class="m-b-0">Friends Groups</h6>
          </span>
          <div class="user-group">
            <img src="assets/images/user/avatar-1.jpg" alt="user-images" class="avatar" />
            <span class="avatar bg-warn-500 text-white">K</span>
            <span class="avatar bg-success-500 text-white">
              <svg class="pc-icon">
                <use xlink:href="assets/fonts/custom-icon.svg#custom-user"></use>
              </svg>
            </span>
          </div>
        </a>
        <a href="javascript:" class="dropdown-item text-muted justify-content-between">
          <span class="flex">
            <svg class="pc-icon m-r-10">
              <use xlink:href="assets/fonts/custom-icon.svg#custom-add-outline"></use>
            </svg>
            <h6 class="m-b-0">Add New</h6>
          </span>
          <div class="user-group">
            <span class="avatar bg-primary-500 text-white">
              <svg class="pc-icon">
                <use xlink:href="assets/fonts/custom-icon.svg#custom-add-outline"></use>
              </svg>
            </span>
          </div>
        </a>
        <mat-divider class="m-b-15 m-t-15"></mat-divider>
        <div class="grid m-b-15">
          <button mat-flat-button color="primary" class="user-logout" (click)="logout()">
            <div class="flex-inline align-item-center">
              <svg class="pc-icon m-r-10">
                <use xlink:href="assets/fonts/custom-icon.svg#custom-logout-1-outline"></use>
              </svg>
              Logout
            </div>
          </button>
        </div>
        <app-card cardClass="m-b-0 user-account-card" [showHeader]="false" padding="16">
          <div class="user-group">
            <img src="assets/images/user/avatar-1.jpg" alt="user-image" class="avatar" />
            <img src="assets/images/user/avatar-2.jpg" alt="user-image" class="avatar" />
            <img src="assets/images/user/avatar-3.jpg" alt="user-image" class="avatar" />
            <img src="assets/images/user/avatar-4.jpg" alt="user-image" class="avatar" />
            <img src="assets/images/user/avatar-5.jpg" alt="user-image" class="avatar" />
            <span class="avatar bg-primary-50 text-primary-500">+20</span>
          </div>
          <h3 class="user-followers">245.3k <small class="text-muted">Followers</small></h3>
          <button mat-flat-button class="upgrade-button">
            <div class="flex-inline align-item-center">
              <svg class="pc-icon m-r-10">
                <use xlink:href="assets/fonts/custom-icon.svg#custom-logout-1-outline"></use>
              </svg>
              Upgrade to Business
            </div>
          </button>
        </app-card>
      </div>
    </ng-scrollbar>
  </mat-menu>
</div>